'use client'

import type { TabType, ProfileTab } from './types'

interface TabNavProps {
  tabs: ProfileTab[]
  activeTab: TabType
  onTabChange: (tab: TabType) => void
}

export function TabNav({ tabs, activeTab, onTabChange }: TabNavProps) {
  return (
    <nav
      className="flex items-center justify-start sm:justify-center gap-2 overflow-x-auto scrollbar-hide bg-white dark:bg-gray-800 rounded-lg p-1 border border-gray-200 dark:border-gray-700"
      aria-label="Tabs"
    >
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => onTabChange(tab.id)}
          className={`flex-shrink-0 flex items-center gap-2 px-4 py-2 rounded-md text-sm font-medium whitespace-nowrap transition-colors ${activeTab === tab.id
            ? 'bg-gradient-to-br from-[var(--theme-primary)] to-[var(--theme-primary-dark)] text-white'
            : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white'
            }`}
        >
          <span>{tab.icon}</span>
          <span className="hidden sm:inline">{tab.name}</span>
          <span className="sm:hidden">{tab.name.split(' ')[0]}</span>
        </button>
      ))}
    </nav>
  )
}
